import * as Sentry from '@sentry/browser';
import { datadogLogs } from '@datadog/browser-logs';
import { Storage } from 'services';

import {
  appStage,
  appEnvironment,
  appVersion,
  sentryDsn,
  sentryRelease,
  datadogToken,
} from 'helpers/constants';

export function initLogging() {
  if (appStage !== 'local') {
    Sentry.init({
      dsn: sentryDsn,
      environment: appEnvironment + '-' + appStage,
      release: sentryRelease,
      attachStacktrace: true,
    });
  }

  if (appStage === 'prod' || 'dev') {
    datadogLogs.init({
      clientToken: datadogToken,
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sampleRate: 100,
      env: appEnvironment + '-' + appStage,
      version: appVersion,
      service: 'mustang',
    });
    // Faster init for user identity
    if (Storage.get('t-id')) {
      datadogLogs.setLoggerGlobalContext({
        email: atob(Storage.get('t-id') as string),
      });
    }
    if (Storage.get('t-org')) {
      datadogLogs.addLoggerGlobalContext('org', atob(Storage.get('t-org') as string));
    }
  }
}
